var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-card',{class:{'ma-3': true, 'hover': hover},attrs:{"outlined":""},on:{"click":_vm.selectHotel}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card-title',{domProps:{"textContent":_vm._s(_vm.hotel.name)}})],1)],1)],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }